/**
 * Whether the /desktop page checks a link's token (2026-10-06, PR 4 of the DocuSign fix).
 *
 * A token on a /desktop link (`?t=`, `?token=`) authorized nothing: the page shows the same desktop without one,
 * and what keeps a person on their own desktops is the page's own-session rule and its vetted workstation address.
 * The token's only effect was to draw the "link expired" card when its check failed, and the sign-in window's
 * "open the live desktop" waited on a minter that has failed since 2026-09-30 before it opened anything. The page
 * now ignores a token, and the window asks for none. REACT_APP_DESKTOP_LINK_TOKEN=validate (repo variable
 * DESKTOP_LINK_TOKEN, wired in deploy.yml) checks it again.
 */
import { buildEnv } from '../../config/buildEnv';

export function desktopLinkTokenChecked(value: string | undefined = buildEnv().REACT_APP_DESKTOP_LINK_TOKEN): boolean {
  return String(value ?? '').trim().toLowerCase() === 'validate';
}
